import React                          from 'react';
import { boardPartNumber as tooltip } from 'pu-data/Tooltips';
import PropTypes                      from 'prop-types'
import TextComponent                  from './base/TextComponent';

const ProjectBoardNumber = (props) => {
  const name = 'part_number';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={props.label}
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      placeholder={props.placeholder}
      groupName={props.groupName}
      className={props.className}
      error={props.error} />
  );
};

ProjectBoardNumber.defaultProps = {
  required: true,
  inputId: 'board_part_number',
  label: '',
  placeholder: 'Board Part Number',
  tooltip,
  className: undefined,
  groupName: undefined,
  error: undefined,
};

ProjectBoardNumber.propTypes = {
  label: PropTypes.string,
  inputId: PropTypes.string,
  required: PropTypes.bool,
  onChangeParameter: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  placeholder: PropTypes.string,
  groupName: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  parameters: PropTypes.shape({ part_number: PropTypes.string }).isRequired,
}

export default ProjectBoardNumber;
